module.exports = __webpack_public_path__ + "static/media/project-development.c4407002.svg";